import { render, staticRenderFns } from "./checkStudent.vue?vue&type=template&id=073789bc&scoped=true&"
import script from "./checkStudent.vue?vue&type=script&lang=js&"
export * from "./checkStudent.vue?vue&type=script&lang=js&"
import style0 from "./checkStudent.vue?vue&type=style&index=0&id=073789bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073789bc",
  null
  
)

export default component.exports